<template>
    <div class="activateBonusIndex flex_v">
        <!-- 分账管理-激活奖励 -->
        <!-- 标题 -->
        <div class="titleBox flex-row ite-c">
            <b>{{topTitle.title}}</b>
            <span v-show="topTitle.subTit!==''">-{{topTitle.subTit}}</span>
            <span v-show="topTitle.thirdTit!==''">-{{topTitle.thirdTit}}</span>
        </div>



        <!-- 筛选框 -->
        <sr-filter class="searchBox" @search="handleSearch" @reset="handleReset">
            <template slot="otherCom">

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.code"
                            placeholder="输入分账ID"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <el-form-item>
                    <el-input
                            v-model="searchForm.params.memberName"
                            placeholder="输入分账对象"
                            @keyup.enter.native="handleSearch"
                            maxlength="25" size="medium" clearable
                    >
                    </el-input>
                </el-form-item>

                <!-- <el-form-item>
                    <el-select  v-model="searchForm.params.status" 
                                placeholder="选择状态"
                                clearable filterable 
                    >
                        <el-option  v-for="item in statusOptions" 
                                    :key="item.id" 
                                    :label="item.status" 
                                    :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item> -->

                <el-form-item>
                    <el-date-picker
                        v-model="searchForm.params.month"
                        type="month"
                        placeholder="选择年月"
                        value-format="yyyy-MM"
                        @change="yearMonthChange"
                        :clearable="false"
                    >
                    </el-date-picker>
                </el-form-item>

            </template>
        </sr-filter>


        <!-- 表格 -->
        <!-- <div class="botTable boxs tableTheadGray" style="min-width:753px"> -->
        <div class="botTable boxs tableTheadGray">
            <div class="tableTop">
                <span class="top_le">{{showYear}}/{{showMonth}}-激活奖励账单</span>

                <div class="flex_h_hR_vC" style="font-size:12px; color:#7F7F7F;">
                    <span>{{showYear}}年{{showMonth}}月实际分账：</span>
                    <span style="font-size:15px; color:#FA6241;"> {{monthTotal.actualTotal}} </span>
                    <span>&nbsp;元，共&nbsp;</span>
                    <span style="color:#333333;"> {{monthTotal.actualCount}} </span>
                    <span style="margin-right:20px;">&nbsp;笔</span>

                    <span>截止当前累计分账：</span>
                    <span style="font-size:15px; color:#FA6241;"> {{monthTotal.cumulativeTotal}} </span>
                    <span>&nbsp;元，共&nbsp;</span>
                    <span style="color:#333333;"> {{monthTotal.cumulativeCount}} </span>
                    <span style="margin-right:20px;">&nbsp;笔</span>

                    <button class="butStyle pinkBtn exportBtn" @click="tableExport">
                        <i class="exportIcon"></i>
                        <span>导出</span>
                    </button>
                </div>
            </div>

            <el-table :data="tableData"
                      style="width: 100%;"
                      border
                      fit
                      highlight-current-row
                      tooltip-effect="dark"
            >
                <el-table-column label="分账ID" prop="code" min-width="140" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="分销标识" prop="configNames" min-width="106" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="分账对象" prop="memberName" min-width="100" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="ICCID" prop="iccid" min-width="170" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="运营商" prop="operator" min-width="78" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="绑定号码" prop="phoneNumber" min-width="108" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="用户" prop="userMemberName" min-width="78" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="网点" prop="website" min-width="88" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="激活时间" prop="activeTime" min-width="152" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="实际分账金额(元)" prop="commission" min-width="129" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span class="orangeT">
                            {{(scope.row.commission).toFixed(2)}}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="分账方式" prop="settlementType" min-width="78" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <!-- <el-table-column label="状态" prop="status" min-width="72" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column> -->
                <el-table-column label="处理时间" prop="processingTime" min-width="152" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="最新稽核时间" prop="auditTime" min-width="152" header-align="center" align="center"
                                 show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" fixed="right" width="170" header-align="center" align="center"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-button @click="goDetailPage(scope)"
                                   class="greenText"
                                   icon="el-icon-search"
                                   type="text"
                                   title="详情">详情
                        </el-button>
                        <el-button @click="goDetailPage(scope)"
                                   class="greenText"
                                   icon="el-icon-document"
                                   type="text"
                                   title="稽核">稽核
                        </el-button>
                    </template>
                </el-table-column>

            </el-table>
            <div class="pageBox boxs">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                               :current-page="searchForm.current" :page-sizes="[10, 20, 30]"
                               :page-size="searchForm.size"
                               layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </div>

    </div>
</template>

<script>
    import SrFilter from '@/components/Common/Filter/Filter';
    import {objectToQueryString} from '@/utils/commonUtils.js';
    import {formatDate} from '@/utils/dateFormatter';
    import {
        getActivateBonusListAPI, //查询激活奖励列表
        getSumCountAndCommissionAPI, //查询佣金总和和记录总数
        // activateBonusExportAPI, //查询激活奖励列表导出
    } from '@/api/Operate/SplitBillManage/activateBonus.js';

    //获取当前日期的上个月份
    let getLastMonth = function() {
        let date = new Date();
        date.setMonth(new Date().getMonth()-1)
        return formatDate(date, 'yyyy-MM');
    }
    
    //获取当前日期的月份
    let getCurrMonth = function() {
        let date = new Date();
        date.setMonth(new Date().getMonth())
        return formatDate(date, 'yyyy-MM');
    }


    // 查询表格的条件
    const searchConst = {
        params: {
            code: null,// 分账ID
            memberName: null,// 分账对象
            // status: null,// 状态
            // month: getLastMonth(),// 年月
            month: getCurrMonth(),// 年月
        },
        current: 1, //当前页码
        size: 10, //每页条数
    }

    export default {
        name: 'activateBonusIndex',
        data() {
            return {
                //标题
                topTitle: {
                    title: '分账管理',
                    subTit: '激活奖励',
                    thirdTit: '',
                },

                // 表格搜索条件
                searchForm: Object.assign({}, searchConst),
                // // 状态
                // statusOptions: [
                //     { id: '0', status:'待审核' },
                //     { id: '1', status:'已同意' },
                //     { id: '2', status:'已拒绝' }
                // ],
                // 表格显示年
                showYear: new Date().getFullYear(),
                // 表格显示月
                showMonth: new Date().getMonth()+1,
                // 表格的月份统计
                monthTotal: {
                    actualTotal: '-', //实际分账：- 元
                    actualCount: '-', //实际分账：- 笔
                    cumulativeTotal: '-', //累计分账：- 元
                    cumulativeCount: '-' //累计分账：- 笔
                },
                // 表格数据
                tableData: [],
                // 表格数据总数
                total: 0,
            }
        },
        components: {
            SrFilter
        },
        computed: {},
        created() {
            // 查询激活奖励列表
            this.getActivateBonusList();
            // 获取表格的累计统计数据
            this.getAllSumCountAndCommission();
            // 获取表格的月份统计数据
            this.getSumCountAndCommission();
        },
        methods: {
            // 导出
            tableExport() {
                const url = `${this.$baseNewUrl}esaleb-service-commission/active-reward-record/activeRewardListExport?accessToken=${this.$accessToken()}&${objectToQueryString(this.searchForm.params)}`;
                window.open(url, '_blank');
            },
            // 获取表格的累计统计数据(接口不传月份，查询所有累计数据)
            async getAllSumCountAndCommission() {
                try {
                    const result = await getSumCountAndCommissionAPI()
                    this.monthTotal.cumulativeTotal = result.data.totalCommission;
                    this.monthTotal.cumulativeCount = result.data.totalCount;

                    this.monthTotal.cumulativeTotal = (this.monthTotal.cumulativeTotal).toFixed(2);
                } catch (e) {
                    console.log(e)
                }
            },
            // 获取表格的月份统计数据(接口传月份，查询月份数据)
            async getSumCountAndCommission() {
                try {
                    const result = await getSumCountAndCommissionAPI({"month": this.searchForm.params.month})
                    this.monthTotal.actualTotal = result.data.totalCommission;
                    this.monthTotal.actualCount = result.data.totalCount;

                    this.monthTotal.actualTotal = (this.monthTotal.actualTotal).toFixed(2);
                } catch (e) {
                    console.log(e)
                }
            },
            // 查询激活奖励列表
            async getActivateBonusList() {
                try {
                    const result = await getActivateBonusListAPI(this.searchForm);
                    this.tableData = result.data.records;
                    this.total = result.data.total;
                } catch (e) {
                    console.log(e)
                }
            },
            // 列表过滤查询
            handleSearch() {
                // 查询激活奖励列表
                this.getActivateBonusList();
                this.getSumCountAndCommission();
            },
            // 搜索重置（清空）
            handleReset() {
                // 初始化参数
                this.searchForm.params = {}
                // // 重置的年月：获取当前日期的上个月份
                // this.searchForm.params.month = getLastMonth();
                // 重置的年月：获取当前日期的月份
                this.searchForm.params.month = getCurrMonth();
                this.handleSearch()
            },
            // 列表每页条数变了
            handleSizeChange(val) {
                this.searchForm.size = val
                this.handleSearch()
            },
            // 列表当前页码变了
            handleCurrentChange(val) {
                this.searchForm.current = val
                this.handleSearch()
            },


            // 年月改变事件-同时改变表格中的显示日期
            yearMonthChange() {
                // 避免清空年月时报错
                if(this.searchForm.params.month) {
                    let splitIndex = this.searchForm.params.month.indexOf('-')
                    this.showYear = this.searchForm.params.month.slice(0, 4);
                    this.showMonth = this.searchForm.params.month.slice(5, 7);
                }
            },
            // 跳转到"激活奖励"详情页
            goDetailPage(scope) {
                this.$router.push({
                    path: '/operate/splitBillManage/activateBonusDetail',
                    query: {
                        phoneNumber: scope.row.phoneNumber,
                        memberId: scope.row.memberId,
                        code: scope.row.code
                    }
                })
            },

        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>

.greenText {
    color: #2DBAA5;
}
.orangeT {
    color: #FA6241;
}

.activateBonusIndex {
}

// 标题
.titleBox {
    width: 100%;
    background: #ffffff;
    height: 44px;
    padding: 0 9px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleBox b {
    color: #2B2727;
    font-size: 15px;
}

.titleBox span {
    color: #7F7F7F;
    font-size: 13px;
}

.titleBox .titRiImg {
    width: 76px;
    height: 24px;
}

// 列表顶部标题
.titleLine {
    width: 100%;
    height: 20px;
    margin-top: 12px;
    box-sizing: border-box;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
}

.titleLine span {
    height: 20px;
    line-height: 20px;
    font-size: 15px;
    font-weight: bold;
    color: #2B2727;
}

.titleLine span::before {
    content: '';
    display: inline-block;
    width: 5px;
    height: 20px;
    margin-right: 6px;
    background: #FA6241;
    vertical-align: middle;
}


.searchBox {
    margin-top: 1px;
}


// 表格
.botTable {
    margin-top: 12px;
    width: 100%;
    // max-height: 408px;
}

.botTable .tableTop {
    height: 54px;
    padding: 0 12px;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    border: 1px solid #EEEEEE;
    border-bottom: none;
}

.botTable .tableTop .top_le {
    font-size: 15px;
    font-weight: bold;
    color: #4E4A46;
}

.botTable .tableTop .exportBtn {
    width: 72px;
    height: 30px;
    line-height: 30px;
    font-size: 13px;
    border-radius: 4px;

    &:hover {
        background-color: rgb(247, 143, 120);
    }
}

.botTable .tableTop .exportBtn .exportIcon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background: url('../../../../assets/images/busy/Finance/FinancialAudit/CashOutAudit/exportBtn.png') no-repeat;
    background-size: 14px 14px;
}

.greenBtn {
    width: 96px;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
    border-radius: 4px;
    color: #ffffff;

    background-color: #2DBAA5;

    &:hover {
        background-color: rgb(115, 196, 183);
    }
}

/* 分页条 */
.pageBox {
    width: 100%;
    padding: 15px 0 10px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
    border: 1px solid #E4E4E4;
    border-top: none;
    //   border-bottom-left-radius: 3px;
    //   border-bottom-right-radius: 3px;
}


// 弹窗按钮-取消按钮
.cancelBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    border-radius: 4px;
    background: #FFFFFF;
    color: #2B2727;
    color: #666666;
    border: 1px solid #EEEEEE;
    box-sizing: border-box;
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;

    &:hover {
        // background-color: #f1f1f1;
        border: 1px solid #d1d0d0;
    }
}

// 弹窗按钮-橙色按钮
.submitBtn {
    width: 120px;
    height: 40px;
    line-height: 40px;
    margin-left: 20px;
    font-size: 14px;
    border-radius: 4px;
    background: #FA6241;
    color: #FFFFFF;

    &:hover {
        background-color: rgb(247, 143, 120);
    }
}

// 分页条2
.pageBox2 {
    // width: 498px;
    width: 100%;
    padding: 10px 0px;
    display: flex;
    justify-content: flex-end;
    background: #ffffff;
}
.pageBox2 .el-pagination {
    padding-right: 0px;
}


</style>
